import type { NavItemDto } from '@/lib/sanity/dto';
import { BaseLink } from './BaseLink';

type NavLinkProps = {
    item: NavItemDto;
    isActive?: boolean;
    className?: string;
    onClick?: () => void;
};

export function NavLink({ item, isActive, className, onClick }: NavLinkProps) {
    const isAnchor = Boolean(item.anchor);
    const ariaCurrent = isActive ? (isAnchor ? 'true' : 'page') : undefined;

    return (
        <BaseLink
            item={item}
            className={className}
            ariaCurrent={ariaCurrent}
            ariaHaspopup={item.openInModal ? 'dialog' : undefined}
            scroll={item.openInModal ? false : undefined}
            onClick={onClick}
        />
    );
}
